import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import useNewReviewed from 'features/useNewReviewed';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import {IntroductionModalHighlightsProps} from 'utils/types/newReviewed';
import {useEffect} from 'react';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import {Button, Modal} from 'letrus-ui';
import styles from './IntroductionModalHighlights.module.scss';

function IntroductionModalHighlights({
  id,
  onClose,
  genre,
  externalReference,
  difference,
  comparisonResult,
}: IntroductionModalHighlightsProps) {
  const {trackEvent} = useTrackEvent();
  const {getComparativeFeedback} = useNewReviewed();

  const {status, icon, color, comparativeWord, points} = getComparativeFeedback(
    externalReference,
    difference,
    comparisonResult,
  );

  const isENEM = genre === 'ENEM';

  useEffect(() => {
    trackEvent('step2_feedback_screen_view');
  }, []);

  return (
    <Modal id={id}>
      <main className={styles.container}>
        <h4>Comparação com a média {isENEM ? 'nacional' : 'Letrus'}</h4>

        <p>
          Clique em ”Entender a análise” para ver sua nota final e os detalhes
          da correção.
        </p>

        <article
          className={`${styles.secondComparativeCard} ${styles[status]}`}
        >
          <FontAwesomeIcon
            icon={['fad', icon as IconName]}
            color={color}
            size="6x"
          />

          <div className={styles.contentCard}>
            <span>Seu desempenho foi</span>
            <b>
              {points} {comparativeWord} da média{' '}
            </b>
            <strong>{genre}</strong>
            <span>
              A média das redações desse gênero em{' '}
              {new Date().getFullYear() - 1} foi de {externalReference} pontos
            </span>
          </div>
        </article>

        <hr />

        <div className={styles.button}>
          <Button onClick={onClose}>
            <FontAwesomeIcon icon={['fad', 'lightbulb-on']} />
            Entender a análise
          </Button>
        </div>
      </main>
    </Modal>
  );
}

export default IntroductionModalHighlights;
